import { zlb_request } from '@zcy/zcy-request';
import { notification } from 'doraemon';

// 需要获取请求接口的前缀
/***
 * remove '/zlb/api/search/'
 */
let prefixUrl = ['unknownUrl']; // 修改sonar空值BUG检测
// 获取可用的url服务接口，异常直接请求当前url
function getPrefixUrl(paramsData, callback) {
  let [url, ...otherParams] = paramsData;
  let newUrl = url;
  if (prefixUrl.find(v => url?.startsWith(v))) {
    return zlb_request('/zlb/api/expense/common/api-gray', { params: { newApi: url } })
      .then(res => {
        newUrl = res?.result || url; // 兜底返回空的情况
        return callback(newUrl, ...otherParams);
      })
      .catch(data => {
        return callback(...paramsData);
      });
  } else {
    return callback(...paramsData);
  }
}

// 原query请求
function queryFn(...rest) {
  return zlb_request(...rest)
    .then(data => {
      if (data?.success) {
        return data?.result;
      }
      return Promise.reject({
        data: { message: data?.message || '请求出错了' },
      });
    })
    .catch(data => {
      notification.error({
        message: data?.data?.message || '请求出错了',
      });
      throw data;
    });
}

// 包装query获取请求的url
function query(...rest) {
  return getPrefixUrl(rest, queryFn);
}

// 原request请求
// 兼容其他地方的request写法
function requestFn(...rest) {
  return zlb_request(...rest)
    .then(data => {
      return data;
    })
    .catch(data => {
      notification.error({
        message: data?.data?.message || '请求出错了',
      });
      throw data;
    });
}

// 包装request获取请求的url
function request(...rest) {
  return getPrefixUrl(rest, requestFn);
}

// 兼容其他地方的request写法，不给报错
function requestWithoutError(...rest) {
  return zlb_request(...rest)
    .then(data => {
      return data;
    })
    .catch(data => {
      throw data;
    });
}

export { request, query, requestWithoutError };
